import { render, staticRenderFns } from "./dataecharts.vue?vue&type=template&id=8bb509fa&scoped=true&"
import script from "./dataecharts.vue?vue&type=script&lang=js&"
export * from "./dataecharts.vue?vue&type=script&lang=js&"
import style0 from "./dataecharts.vue?vue&type=style&index=0&id=8bb509fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb509fa",
  null
  
)

export default component.exports